import { type ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
interface ProtectedRouteProps {
  children: ReactNode;
}
function ProtectedRoute({ children }: ProtectedRouteProps) {
  const auth = useAuth();
  const location = useLocation();
  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading && !auth.activeNavigator) {
      // Guardar la ruta actual para redirigir después del login
      const returnUrl = location.pathname + location.search;
      auth.signinRedirect({
        state: { returnUrl },
      });
    }
  }, [
    auth.isAuthenticated,
    auth.isLoading,
    auth.activeNavigator,
    auth,
    location,
  ]);
  if (auth.isLoading) {
    return <div>Verificando autenticación...</div>;
  }
  if (auth.error) {
    return (
      <div>
        <p>Error de autenticación: {auth.error.message}</p>
        <button onClick={() => auth.signinRedirect()}>
          Intentar nuevamente
        </button>
      </div>
    );
  }
  if (!auth.isAuthenticated) {
    return <div>Redirigiendo al inicio de sesión...</div>;
  }
  return <>{children}</>;
}
export default ProtectedRoute;
